import { batch } from 'react-redux';

import { TContextDispatch } from '~/src/entities/speed-bonus/context';
import { setRoutersPrice } from '~/src/entities/speed-bonus/context/actions';
import { incrementQuantity } from '~/src/entities/speed-bonus/context/actions/incrementQuantity';
import { IPreparedRouter } from '~/src/entities/speed-bonus/context/actions/setRouters';

export const addRouter = (router: IPreparedRouter, cost: number) => (dispatch: TContextDispatch) => {
    const selectedPrice = router.prices.find(el => el.cost === cost);

    if (!selectedPrice) {
        return;
    }

    batch(() => {
        dispatch(setRoutersPrice({
            id: router.id,
            duration: selectedPrice.duration,
        }));
        dispatch(incrementQuantity(router.id));
    });
};
